import { format } from "date-fns";
import type { DateDefaultContext } from "../date/dateDefaults";
import { resolveDefaultDate } from "../date/dateDefaults";

interface DateValue {
  date: string;
  include_time: boolean;
}

interface DueDateFormValue {
  from_date: DateValue;
  to_date: DateValue;
}

export const normalizeDueDateDefaultValue = (
  value: string | DueDateFormValue,
  { timezone }: DateDefaultContext,
): DueDateFormValue | undefined => {
  if (typeof value === "string") {
    const resolved = resolveDefaultDate(value, timezone);
    if (!resolved) return undefined;

    // The control writes a date-only boundary in this shape and every consumer reparses it as a
    // browser-local day, so a default has to match it rather than emit a UTC-parsed "YYYY-MM-DD".
    return {
      from_date: { date: "", include_time: false },
      to_date: { date: format(resolved, "MMM dd, yyyy"), include_time: false },
    };
  }
  return value;
};
